import { normalizeZoneDigits, trainingZoneColorForLabel } from '../../utils/trainingZones';
import type { WeekZones, ZoneDetail } from './types';


export function zoneLabelOrder(label: string): number {
  const normalized = normalizeZoneDigits(label);
  return Number(normalized.match(/\d+(?:\.\d+)?/)?.[0] ?? 999);
}

export function zoneColor(label: string, index: number): string {
  return trainingZoneColorForLabel(label, index);
}

/** API labels remain the identities; missing/zero zones must not shift other zones. */
export function getZoneDetails(week: WeekZones): ZoneDetail[] {
  return week.zoneDetails?.map((zone, index) => ({ ...zone, color: zoneColor(zone.label, index) })) ?? [week.z1, week.z2, week.z3, week.z4, week.z5].map((hrs, i) => ({
    label: `Z${i + 1}`, hrs, color: zoneColor(`Z${i + 1}`, i),
  }));
}

export function getZoneLegend(data: WeekZones[]): ZoneDetail[] {
  return Array.from(new Map(data.flatMap(getZoneDetails).map(zone => [zone.label, zone])).values());
}

export function formatZoneHours(hours: number): string {
  const minutes = Math.round(Math.max(0, hours) * 60);
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}
